import { initMainHeader } from '../js/src/header-init';
import { getQuoteFormInit } from "../js/src/get-quote-form";
import initCustomIntegration from "../js/src/custom-integration-common";
import { loadYoutubeVideoPlayer } from "../js/src/video-list";
import '../scss/pages/amd-custom.scss';
import { addThirdPartyLoad } from "../js/src/utils";

initMainHeader();


addThirdPartyLoad(() => {
    getQuoteFormInit();
    loadYoutubeVideoPlayer(true);
});

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomIntegration);
} else {
    initCustomIntegration();
}






